import styled from "styled-components";
import { BsArrowUpRightCircle } from "react-icons/bs";

export const LiveIcon = styled(BsArrowUpRightCircle)`
  transition: 0.3s ease-in-out;
`;

export const StyledPlayground = styled.section`
  position: relative;
  isolation: isolate;
  background: radial-gradient(
      circle at top right,
      rgba(148, 92, 255, 0.25),
      transparent 45%
    ),
    radial-gradient(circle at bottom left, rgba(255, 120, 230, 0.2), transparent 50%),
    ${({ theme }) => theme.backgroundColor.dark};
  color: ${({ theme }) => theme.color.light};
  margin: auto;
  padding: clamp(4rem, 7vw, 6rem) clamp(1.5rem, 6vw, 5rem);
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(10, 10, 18, 0.9), rgba(8, 8, 13, 0.85));
    mix-blend-mode: soft-light;
    opacity: 0.5;
    z-index: -1;
  }
`;

export const PlaygroundProjectContainer = styled.div`
  margin-top: 3rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.5rem;
  position: relative;
  z-index: 1;
`;


export const ServiceContainer = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 24px;
  padding: 2rem;
  min-height: 320px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: rgba(19, 19, 28, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.35);
  transform-origin: right bottom;
  transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);

  &:before {
    content: "";
    position: absolute;
    inset: 0;
    opacity: 0;
    background: radial-gradient(circle at 20% 20%, rgba(255, 72, 251, 0.35), transparent 55%);
    transition: opacity 0.4s ease;
    z-index: 0;
  }

  &:hover {
    transform: translateY(-8px) scale(1.01);
    border-color: rgba(255, 72, 251, 0.4);
  }

  &:hover:before {
    opacity: 1;
  }
`;


export const Title = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  position: relative;
  z-index: 1;
`;

export const Description = styled.p`
  font-size: 1rem;
  line-height: 1.7;
  word-wrap: break-word;
  position: relative;
  z-index: 1;
  color: ${({ theme }) => theme.color.lightGray};
`;

export const ServiceIcon = styled.div`
  width: 72px;
  height: 72px;
  background: linear-gradient(135deg, #ff48fb, #8eaaff);
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 2rem;
  box-shadow: 0 15px 35px rgba(255, 72, 251, 0.35);
  z-index: 1;
`;

export const ServiceEyebrow = styled.span`
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.25em;
  color: #b794f4;
  z-index: 1;
`;

export const ServiceStack = styled.span`
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 0.35rem 0.85rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.05);
  color: ${({ theme }) => theme.color.light};
`;

export const ServiceFooter = styled.div`
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  z-index: 1;
`;

